import { render, staticRenderFns } from "./other-fee.vue?vue&type=template&id=215478a2&scoped=true&"
import script from "./other-fee.vue?vue&type=script&lang=js&"
export * from "./other-fee.vue?vue&type=script&lang=js&"
import style0 from "./other-fee.vue?vue&type=style&index=0&id=215478a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215478a2",
  null
  
)

export default component.exports